import React from 'react'

export default function Phone (props) {
  return (
    <svg viewBox='0 0 64 64' width={props.width || 200} height={props.height || 200} fill={props.color || '#515151'}>
      <path fill={props.color || '#444444'} d='M46,64H18c-5.8,0-10.6-4.8-10.6-10.6V10.6C7.4,4.8,12.1,0,18,0H46c5.9,0,10.6,4.7,10.6,10.6v42.8C56.6,59.3,51.9,64,46,64z M18,4.1c-3.6,0-6.5,2.9-6.5,6.5v42.8c0,3.6,2.9,6.5,6.5,6.5H46c3.6,0,6.5-2.9,6.5-6.5V10.6c0-3.6-2.9-6.5-6.5-6.5H18z' />
      <path fill={props.color || '#00D8A0'} d='M26.4,50.6c0,3.1,2.5,5.6,5.6,5.6c3.1,0,5.6-2.5,5.6-5.6c0-3.1-2.5-5.6-5.6-5.6S26.4,47.5,26.4,50.6C26.4,50.6,26.4,50.6,26.4,50.6z' />
      <path fill={props.color || '#444444'} d='M44.7,12.1H19.3c-0.8,0-1.4-0.6-1.4-1.4c0-0.8,0.6-1.4,1.4-1.4h25.3c0.8,0,1.4,0.6,1.4,1.4S45.4,12.1,44.7,12.1L44.7,12.1z' />
    </svg>
  )
}
